/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 */

/**
 * Company Reach tab (C4, renamed from "Opportunities" per user
 * decision 2026-08-27).
 *
 * Honest framing: this is network concentration, not job listings.
 * "You have 73 connections at Manhattan Associates. This is a strong
 * network for outreach in the WMS domain."
 *
 * Consumes the topCompanies from GET /api/network/dashboard's overview
 * block — no separate endpoint needed. Sorted by connection count.
 */

import React from 'react';

export default function CompanyReach({ overview }) {
  const topCompanies = overview?.topCompanies || [];

  if (topCompanies.length === 0) {
    return (
      <div style={emptyReasonStyle}>
        <h3 style={{ margin: '0 0 8px' }}>No company data yet</h3>
        <p style={{ margin: 0, fontSize: '14px' }}>
          Import your network CSV to see where your contacts work and
          which companies you have the strongest reach into.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div style={introStyle}>
        <h3 style={{ margin: '0 0 8px' }}>Where your network sits</h3>
        <p style={{ margin: 0, fontSize: '13px', color: '#475569' }}>
          Ranked by how many of your imported contacts work at each
          company. Use it to identify strong-relationship targets for
          outreach — this is not a jobs board.
        </p>
      </div>

      <div style={tableStyle}>
        {topCompanies.map((c, i) => (
          <div key={i} style={rowStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ fontWeight: 600 }}>{c.name || '(no name)'}</div>
              <div style={{ color: '#0891b2', fontWeight: 600 }}>
                {c.connections} connection{c.connections === 1 ? '' : 's'}
              </div>
            </div>
            {c.connections >= 20 && (
              <div style={{ marginTop: '6px', fontSize: '13px', color: '#0f766e' }}>
                Strong network — a good target for outreach.
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const introStyle = {
  background: '#f8fafc',
  padding: '16px',
  borderRadius: '8px',
  marginBottom: '16px'
};

const tableStyle = {
  background: '#fff',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  overflow: 'hidden'
};

const rowStyle = {
  padding: '14px 16px',
  borderBottom: '1px solid #f1f5f9'
};

const emptyReasonStyle = {
  padding: '40px 20px',
  textAlign: 'center',
  color: '#475569'
};
